function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1956(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 89.52,
    height: 47.1,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.8500000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.76,
    y: 23.55,
    fontFamily: "Arial"
  }, "\n        Mohave\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 47.1,
    width: 89.52,
    height: 50.31,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.385
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.76,
    y: 72.255,
    fontFamily: "Arial"
  }, "\n        Apache\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 97.41,
    width: 89.52,
    height: 52.4,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.76,
    y: 123.61,
    fontFamily: "Arial"
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 149.82,
    width: 89.52,
    height: 76.81,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.801666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.76,
    y: 188.225,
    fontFamily: "Arial"
  }, "\n        Graham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 226.63,
    width: 89.52,
    height: 84.79,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.59875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.76,
    y: 269.025,
    fontFamily: "Arial"
  }, "\n        Greenlee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 311.42,
    width: 89.52,
    height: 112.62,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.76,
    y: 367.73,
    fontFamily: "Arial"
  }, "\n        Navajo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 424.04,
    width: 89.52,
    height: 120.14,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.19
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.76,
    y: 484.11,
    fontFamily: "Arial"
  }, "\n        Coconino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 544.18,
    width: 89.52,
    height: 155.82,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.38
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.76,
    y: 622.0899999999999,
    fontFamily: "Arial"
  }, "\n        Gila\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.52,
    y: 0,
    width: 134.44,
    height: 121.26,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.322857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 156.74,
    y: 60.63,
    fontFamily: "Arial"
  }, "\n        Yavapai\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.95,
    y: 0,
    width: 150.98,
    height: 121.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.252000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.44,
    y: 60.63,
    fontFamily: "Arial"
  }, "\n        Pinal\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.94,
    y: 0,
    width: 154.75,
    height: 121.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 30.315
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 452.315,
    y: 60.63,
    fontFamily: "Arial"
  }, "\n        Yuma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 529.69,
    y: 0,
    width: 170.31,
    height: 121.26,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.322857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 614.845,
    y: 60.63,
    fontFamily: "Arial"
  }, "\n        Cochise\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 89.52,
    y: 121.26,
    width: 183.49,
    height: 578.74,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 45.8725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 181.265,
    y: 410.63,
    fontFamily: "Arial"
  }, "\n        Pima\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 121.26,
    width: 427,
    height: 578.74,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 53.375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 486.5,
    y: 410.63,
    fontFamily: "Arial"
  }, "\n        Maricopa\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1956);
export default __webpack_public_path__ + "static/media/1956.1b74bf04a1e63c5dd1d98af456473485.svg";
export { ForwardRef as ReactComponent };